import type { TranslateFn, UploadFileRejection } from 'src/lib/pricelist-utils';
import { describeReceivedFileType } from 'src/lib/pricelist-utils';

/** Eaton DSP packs arrive as `.xlsx`, binary `.xlsb`, or classic `.xls`. */
export const EATON_DSP_ACCEPT =
  '.xls,.xlsx,.xlsb,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.binary.macroEnabled.12';

export function isEatonDspExcelFile(file: File): boolean {
  return /\.(xlsx|xlsb|xls)$/i.test(file.name);
}

export function validateEatonDspFile(
  file: File,
  gt: TranslateFn,
): UploadFileRejection | null {
  if (isEatonDspExcelFile(file)) return null;
  return {
    kind: 'unsupported',
    title: gt('Unsupported file format', {
      context: 'toast title when an unsupported file type is selected',
    }),
    message: `${gt('Got a file of type', {
      context:
        'prefix before the type of an unsupported file the user tried to upload',
    })} “${describeReceivedFileType(file)}”. ${gt(
      'Please upload a file ending in .xls, .xlsx, or .xlsb.',
      {
        context: 'toast message listing the supported Eaton DSP Excel formats',
      },
    )}`,
  };
}
